import { useTranslation } from 'react-i18next';
import ActionsDialog from '../../../../components/ActionsDialog/ActionsDialog';

interface ValuationMethodWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export default function ValuationMethodWarningDialog({ open, onClose, onContinue }: ValuationMethodWarningDialogProps) {
  const { t } = useTranslation();

  return (
    <ActionsDialog
      open={open}
      onClose={onClose}
      dataTestId='valuation-method-warning-dialog'
      dialogTitle={t('inventory.inventoryValuationSettings.warningDialog.title')}
      dialogContentText={t('inventory.inventoryValuationSettings.warningDialog.message')}
      closeButtonText={t('buttonText.cancel')}
      closeButtonVariant='text'
      actionButtonText={t('buttonText.continue')}
      actionButtonVariant='contained'
      onActionClick={onContinue}
    />
  );
}
